import { g } from '../ability';

export default function defineFreeUserAbilities(can) {
  can([g.VIEW], g.BILL_ANNOTATION_TOOLTIP);
  can([g.VIEW], g.TRACK_BILL_CONFIRM);
  can([g.VIEW], g.BILL_SEARCH);
  can([g.TRACK, g.VIEW], g.BILL);
  can([g.VIEW], g.SIDEBAR_SEARCH);
  can([g.VIEW], g.SIDEBAR_WORKSPACE);
  can([g.VIEW], g.SIDEBAR_BILLS);
  can([g.VIEW], g.SIDEBAR_SEARCH_NAV_GROUP);
  can([g.SEND], g.BILL);
  can([g.VIEW], g.BILL_SUMMARY);
}
